var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view--process"},[_vm._v(" Hello "),_c('process-timer',{attrs:{"label":"Process 1","time":120}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }